var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"wrapper site-header__wrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"logo"},[_c('h1',[_c('img',{attrs:{"src":require("@/assets/tool-logo.png")}})])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }